import { render, staticRenderFns } from "./materLend.vue?vue&type=template&id=04ae1c22&"
import script from "./materLend.vue?vue&type=script&lang=js&"
export * from "./materLend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports